import { render, staticRenderFns } from "./ExpenseCard.vue?vue&type=template&id=3fb54aee&scoped=true"
import script from "./ExpenseCard.vue?vue&type=script&lang=js"
export * from "./ExpenseCard.vue?vue&type=script&lang=js"
import style0 from "./ExpenseCard.vue?vue&type=style&index=0&id=3fb54aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb54aee",
  null
  
)

export default component.exports